import React from "react";
import { Box, Skeleton, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import BackgroundLayout from "../../../components/custom-backgrounds/BackgroundLayout";
import { SKY_BLUE } from "../../../utility/constants/common-constants";

const MyCarePlanPageSkeleton = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <BackgroundLayout
      variant={isMobile ? "carePlanPageMobile" : "carePlanPageDesktop"}
      height={{ xs: "13rem", sm: "14rem", md: "29rem" }}
      backgroundColor={SKY_BLUE}
      showFooter={false}
    >
      <Box
        p={2}
        sx={{
          maxWidth: "990px",
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <Typography variant="h1" mb={3}>
          {t("carePlanPage.myCarePlan")}
        </Typography>

        <Stack direction="row" spacing={2} mb={4}>
          {[70, 130, 150, 150, 110].map((width, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={width}
              height={36}
              sx={{ borderRadius: "18px" }}
            />
          ))}
        </Stack>

        {/* Week 6-8 Box */}
        <Box mb={2} p={2} borderRadius={2} bgcolor="#f5f5f5">
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={100}
            sx={{ my: 1 }}
          />
          <Skeleton variant="text" width="60%" />
        </Box>

        {/* Additional Placeholder Items */}
        {[1, 2, 3].map((_, idx) => (
          <Box key={idx} mb={2} p={2} borderRadius={2} bgcolor="#f5f5f5">
            <Skeleton variant="text" width="30%" height={25} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={80}
              sx={{ my: 1 }}
            />
            <Skeleton variant="text" width="50%" />
          </Box>
        ))}
      </Box>
    </BackgroundLayout>
  );
};

export default MyCarePlanPageSkeleton;
